import { render, staticRenderFns } from "./ClipAdder.vue?vue&type=template&id=5088ca00&scoped=true"
import script from "./ClipAdder.vue?vue&type=script&lang=js"
export * from "./ClipAdder.vue?vue&type=script&lang=js"
import style0 from "./ClipAdder.vue?vue&type=style&index=0&id=5088ca00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5088ca00",
  null
  
)

export default component.exports